import React from 'react';

interface SelectFieldProps
    extends React.SelectHTMLAttributes<HTMLSelectElement> {
    label: string;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    children,
    id,
    ...props
}) => (
    <label className="field" htmlFor={id}>
        <span>{label}</span>
        <select id={id} {...props}>
            {children}
        </select>
    </label>
);

export default SelectField;
